;(function() {
  'use strict'

  angular.module('core.stripe', [])
})()
